export default "__VITE_ASSET__phbHvlmm__"